import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { TranslateModule } from "@ngx-translate/core";
import { PopoverModule } from "ngx-popover";
import { GenericModalModule } from "../../../../dms/layout/modals/generic-modal/generic-modal.module";
import { CalendarioModule } from "../../../../shared/components/calendario/calendario.module";
import { PipesModule } from "../../../../shared/_pipes/pipes.module";
import { DirectivesModule } from "../../../directives/directives.module";
import { ContactInformationComponent } from "./contact-information.component";
import { DropDownListModule } from "@progress/kendo-angular-dropdowns";

@NgModule({
    imports: [
        CommonModule,
        TranslateModule,
        ReactiveFormsModule,
        GenericModalModule,
        PopoverModule,
        PipesModule,
        DirectivesModule,
        CalendarioModule,
        DropDownListModule
    ],
    declarations: [
        ContactInformationComponent
    ],
    exports: [
        ContactInformationComponent
    ]
})
export class ContactInformationModule { }
